import { CurrentPlanVariant } from '../current-plan-banner/types';

interface VariantAlertCopy {
  title: string;
  severity: 'info' | 'warning';
}

export const ALERT_COPY: Record<CurrentPlanVariant, VariantAlertCopy> = {
  [CurrentPlanVariant.CUSTOM]: {
    title: 'Custom Plan',
    severity: 'info',
  },
  [CurrentPlanVariant.LEGACY]: {
    title: 'Legacy Plan',
    severity: 'warning',
  },
};
